<template>

  <mw-dialog :size="isNewStyle?'large_large':'small_large'" :appendToBody="false" :footerButton="footerButton" ref="dialog" title="选择用户">

    <el-col :span="isNewStyle?8:12" :style='{"height":"calc(100% - "+(params.footerHeight||0)+"px)","overflow-x":"hidden"}'>
      <mw-tree :url="deptTreeUrl" ref="tree"
               :async="true" :expandedFirst="true" :defaultParams="defaultTreeParams"
               :multiple="false" @changed="changed" :aliasId="treeAliasId"></mw-tree>
    </el-col>

    <el-col :span="isNewStyle?8:12" :style='{"height":"calc(100% - "+(params.footerHeight||0)+"px)"}'>
      <mw-table ref="dataTable" :columns="columns" :defaultParamsAutoLoad="true"
                @dataLoaded="candidateLoaded" @selectChange="candidateSelectChange"
                :autoLoad="false" :pagination="false" :defaultParams="defaultParams"
                :api="api" :singleSelect="params.multiple==undefined ?true:!params.multiple">
      </mw-table>
      <!--<el-input v-model="searchQcon" placeholder="搜索用户" @keyup.enter="searchUser">-->
        <!--<el-button slot="append" icon="fa fa-search" @click="searchUser"></el-button>-->
      <!--</el-input>-->
    </el-col>
    <el-col v-if="isNewStyle" :span="8" :style='{"height":"calc(100% - "+(params.footerHeight||0)+"px)", "padding-left":"10px"}'>
      <el-table  ref='multipleTable' class="mw-table" :data="selectedData">
        <el-table-column
          label="已选人员"
          prop="name"
          width="180">
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="removeSelectedData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <component v-if="params.footerComp" :is="params.footerComp" :params="thisComp" ref="footerComp"></component>
  </mw-dialog>

</template>

<script>
    import { mapGetters } from 'vuex'
    import unit from "../../../../../common/vuex/modules/org/unit";
    export default {
        props: {
          params: {
            type: Object
          }
        },
        data() {
            return {
              deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
              thisComp:this,
              api: 'org.listUser',
              footerButton: [{
                label: '确定',
                func: this.save
              }],
              searchQcon:"",
              selectedData:[],
              isNewStyle:this.params.isNewStyle && this.params.multiple,
              defaultParams: {},
              //defaultTreeParams:{},
              treeAliasId:'departmentId',
              columns: [{type: 'selection'},{type: 'index'},
              {prop: 'name',label: '名称',tooltip: true}]
            }
        },

       mounted() {
         setTimeout(()=>{
           this.show();
         },200)
         //this.defaultTreeParams = {rootId:this.expUser.dep.loginUnit.id};
       },
        computed: {
          ...mapGetters([
            'expUser'
          ]),
          defaultTreeParams(){
            let result;
            if(this.params && this.params.rootId){
              result ={rootId:this.params.rootId};
            }else if(this.expUser.dep.loginUnit) {
              result ={rootId:this.expUser.dep.loginUnit.id};
            }else{
              result={}
            }

             if (!(this.userInfo && this.userInfo.developer)) result.listAble = true;
             return result;
          }
        },
      /*watch:{
        'expUser.dep.loginUnit.id'(){
          this.defaultTreeParams = {rootId:this.expUser.dep.loginUnit.id};
        }
      },*/

       methods:{
         filterCandidates(){
           if(!this._currentCandidates)return;
           const dataList=this._currentCandidates.filter(c=>this.selectedData.findIndex(d=>d.id===c.id)<0);
           this.$refs.dataTable.dataList= dataList
         },
         candidateLoaded(dataList){
           if(!this.isNewStyle)return;
           this._currentCandidates=dataList;
           this.filterCandidates();
         },
         candidateSelectChange(selections){
           if(!this.isNewStyle)return;
           this.selectedData=this.selectedData.concat(selections)
           this.$refs.dataTable.clearSelection();
           this.filterCandidates();
         },
         removeSelectedData(row){
           this.selectedData=this.selectedData.filter(d=>d.id!==row.id);
           this.filterCandidates();
         },
        changed(data){
          this.refreshTableDefaultParams({ departmentId : data.id});
        },

        refreshTableDefaultParams(params) {
          this.defaultParams=params;
        },
         fillDepInfo(data) {
          let tree=this.$refs.tree;
          let node=tree.getSelected();
          if(!node)return;
          let unitNode=node;
           while (unitNode.type === "file") {
             unitNode = tree.getNode(unitNode.parentId);
             if(!unitNode)break;
           }
           if (data) {
             data.forEach(d => {
               d.departmentId=node.id;
               d.departmentName=node.text;
               if (unitNode) {
                 d.unitId=unitNode.id;
                 d.unitName=unitNode.text;
               }
             });
           }
         },
        save(){
          let data = this.isNewStyle? this.selectedData : this.mwRef('dataTable').getMultipleSelection();
          if(data.length < 1){
              this.mwMsg('info','请选择用户！');
              return;
          }
          this.fillDepInfo(data);
          this.params.func(data,this.$refs.footerComp,this);
          this.mwRef('dialog').hide();
        },
        show(){
          this.mwRef('dialog').show();
        },
       close(){
         this.mwRef('dialog').hide();
       },
         searchUser(){

         },
         clearSearch(){

         }

      }
    }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/form/user-select.vue